// import { cn } from '@/lib/utils';

// export const ScoreCard = () => {
//   return (
//     <section className='grid grid-cols-2 md:grid-cols-4 gap-6 items-center mt-16'>
//       <article className='bg-[#0E171D] text-center rounded-md h-[150px] md:h-[200px] flex flex-col justify-center relative'>
//         <h3 className='title text-[#4ABB5D]'>1000+</h3>
//         <p className='description'>Students taught</p>

//         <BorderBar className='via-[#4ABB5D]' />
//       </article>
//       <article className='bg-[#0E171D] text-center rounded-md h-[150px] md:h-[200px] flex flex-col justify-center relative'>
//         <h3 className='title text-[#FF48D7]'>150k+</h3>
//         <p className='description'>Followers</p>

//         <BorderBar className='via-[#FF48D7]' />
//       </article>
//       <article className='bg-[#0E171D] text-center rounded-md h-[150px] md:h-[200px] flex flex-col justify-center relative'>
//         <h3 className='title text-[#56BAE4]'>10-20+</h3>
//         <p className='description'>Years of experience</p>

//         <BorderBar className='via-[#56BAE4]' />
//       </article>
//       <article className='bg-[#0E171D] text-center rounded-md h-[150px] md:h-[200px] flex flex-col justify-center relative'>
//         <h3 className='title text-[#BDAF31]'>2</h3>
//         <p className='description'>Courses</p>

//         <BorderBar className='via-[#BDAF31]' />
//       </article>
//     </section>
//   );
// };

'use client';

import { MainMenusGradientCard } from '@/components/card/animatedCard';
import { DMLink } from '@/components/link';

export function ScoreCard() {
  return (
    <div className='relative grid w-full grid-cols-2 gap-2 p-2 lg:grid-cols-4 place-items-center items-stretch mt-16'>
      <MainMenusGradientCard
        className='p-4'
        description='Students taught'
        title='3000+'
        borderColor='4ABB5D'
        value={3000}
        suffix='+'
      ></MainMenusGradientCard>
      <MainMenusGradientCard
        className='p-4'
        description='Followers'
        title='200k+'
        borderColor='FF48D7'
        value={200}
        suffix='k+'
      >
        If leave the card empty, it will still look good
      </MainMenusGradientCard>
      <MainMenusGradientCard
        description='Years of experience'
        title='10-20+'
        borderColor='56BAE4'
        value={20}
        prefix='10-'
        suffix='+'
      />
      <DMLink href='/courses' className='!block w-full'>
        <MainMenusGradientCard description='Courses' title='2' borderColor='BDAF31' value={2} />
      </DMLink>
    </div>
  );
}
